import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdatePreferencesBody } from './update-preferences-request';
import type { IUpdatePreferencesResponse } from './update-preferences-response';
import { updatePreferencesResponseSchema } from './update-preferences-response';

export async function updatePreferencesApi(
  body: IUpdatePreferencesBody,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IUpdatePreferencesResponse>> {
  return putRequest<IUpdatePreferencesResponse>({
    path: '/account/preferences',
    body,
    schema: updatePreferencesResponseSchema,
    options,
  });
}
